export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-shape/src/identity.js
// module id = ../../../../d3-shape/src/identity.js
// module chunks = 3